var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_687_2735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.06177,
    y: 6.88867,
    width: 5.49765,
    height: 9.72222,
    rx: 2.74883,
    fill: "#FE970A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_687_2735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 9.89577,
    height: 17.5,
    rx: 4.08333,
    fill: "white",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.29167,
    y: 3.29167,
    width: 9.31244,
    height: 16.9167,
    rx: 3.79167,
    stroke: "#F05B55",
    strokeOpacity: 0.0538407,
    strokeWidth: 0.583333
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_687_2735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4534 9.58894L16.2735 10.1308L13.6631 17.9661C13.5365 18.3482 13.2874 18.6576 12.976 18.8701C12.5281 19.1719 11.9505 19.2712 11.396 19.0905C10.4523 18.7875 9.93794 17.7874 10.2446 16.8607L13.0349 8.48357L16.4534 9.58894Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4534 9.58894L16.2735 10.1308L13.3662 9.2838C13.3662 9.2838 11.2405 15.9013 10.779 17.1589C10.3174 18.4165 11.7353 19.5769 12.9673 18.8752C12.9693 18.8734 12.9722 18.8717 12.976 18.8701C12.5281 19.1719 11.9505 19.2712 11.396 19.0905C10.4523 18.7875 9.93794 17.7874 10.2446 16.8607L13.0349 8.48357L16.4534 9.58894Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.568 11.4811L13.3948 17.8811C13.1351 18.6614 12.2766 19.0878 11.482 18.8311C11.3662 18.7919 11.2566 18.7421 11.1559 18.6817C10.5741 18.3259 10.2888 17.6135 10.5117 16.9471L12.4694 11.0734L12.7787 11.1144L15.568 11.4811Z",
    fill: "#FE970A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1559 18.6817C10.5741 18.3259 10.2888 17.6135 10.5117 16.9471L12.4694 11.0734L12.7787 11.1144C12.1126 13.169 11.0827 16.332 10.7784 17.1596C10.5623 17.7492 10.7598 18.3164 11.1559 18.6817Z",
    fill: "#000091"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0088 18.0726C12.9398 18.0497 12.9042 17.9789 12.9246 17.911L15.385 10.5282C15.4082 10.4605 15.4803 10.423 15.5493 10.4459C15.6182 10.4688 15.6538 10.5396 15.6306 10.6073L13.1729 17.993C13.1498 18.0579 13.0749 18.0953 13.0088 18.0726Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.9145 9.62066L16.8847 9.70731L16.8445 9.832C16.831 9.8754 16.7821 9.89765 16.7379 9.88431L12.6104 8.54882C12.5662 8.53547 12.5435 8.48742 12.557 8.44402L12.6268 8.23542C12.6403 8.19203 12.6892 8.16978 12.7334 8.18312L13.1749 8.32479L16.8609 9.51861C16.9051 9.53195 16.928 9.57726 16.9145 9.62066Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8847 9.70731L16.8445 9.832C16.831 9.8754 16.7821 9.89765 16.7379 9.88431L12.6104 8.54882C12.5662 8.53547 12.5435 8.48742 12.557 8.44402L12.6268 8.23542C12.6403 8.19203 12.6892 8.16978 12.7334 8.18312L13.1749 8.32479L13.1368 8.51576L16.8847 9.70731Z",
    fill: "black",
    fillOpacity: 0.516308
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0388 6.2471L17.0895 9.10281L17.0296 9.2816C16.98 9.4251 16.8215 9.50501 16.6754 9.456L12.9754 8.26145C12.8264 8.21229 12.7476 8.05655 12.7944 7.9129L13.8064 4.87855C13.8532 4.7349 14.0117 4.655 14.1579 4.704L14.4752 4.80609L17.8607 5.8987C18.0068 5.94771 18.0884 6.1036 18.0388 6.2471Z",
    fill: "#01B37A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 5.20898C14.9114 5.20898 16.4203 5.91657 17.8035 6.18478C17.8035 6.18478 16.4638 5.56876 14.9114 5.20898Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4073 8.10964L13.2306 8.05352C13.2059 8.04396 13.1932 8.01848 13.2001 7.99403L14.1388 5.17913C14.1457 5.15468 14.1716 5.14225 14.1965 5.14907L14.3758 5.20808C14.4007 5.2149 14.4134 5.24038 14.4037 5.26468L13.4678 8.07973C13.4581 8.10403 13.4322 8.11646 13.4073 8.10964Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0398 8.31283L13.8604 8.25657C13.8357 8.247 13.823 8.22152 13.8326 8.19722L14.7686 5.38217C14.7783 5.35787 14.8042 5.34544 14.8291 5.35226L15.0056 5.41113C15.0305 5.41794 15.0432 5.44342 15.0363 5.46787L14.0975 8.28278C14.0906 8.30722 14.0647 8.31965 14.0398 8.31283Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6683 8.51785L14.4918 8.45898C14.4669 8.45216 14.4542 8.42669 14.4611 8.40224L15.3998 5.58733C15.4067 5.56288 15.4326 5.55045 15.4575 5.55727L15.634 5.61614C15.6589 5.62296 15.6744 5.64858 15.6647 5.67288L14.7287 8.48794C14.7191 8.51224 14.6931 8.52466 14.6683 8.51785Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8.72112L15.1207 8.6621C15.0958 8.65528 15.0831 8.62981 15.09 8.60536L16.0287 5.79045C16.0384 5.76615 16.0643 5.75373 16.0892 5.76054L16.2659 5.81666C16.2906 5.82623 16.3033 5.8517 16.2964 5.87615L15.3576 8.69106C15.3508 8.71551 15.3221 8.72779 15.3 8.72112Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9287 8.9261L15.7522 8.86723C15.7274 8.86041 15.7119 8.83479 15.7216 8.81049L16.6603 5.99558C16.6672 5.97113 16.6931 5.95871 16.718 5.96553L16.8946 6.02164C16.9194 6.03121 16.9321 6.05669 16.9252 6.08113L15.9864 8.89604C15.9795 8.92049 15.9536 8.93292 15.9287 8.9261Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5571 9.13012L16.3806 9.07125C16.3557 9.06443 16.343 9.03896 16.3499 9.01451L17.2887 6.1996C17.2956 6.17515 17.3244 6.16012 17.3464 6.16954L17.5258 6.22581C17.5506 6.23538 17.5633 6.26085 17.5536 6.28515L16.6176 9.10021C16.6079 9.12451 16.582 9.13693 16.5571 9.13012Z",
    fill: "black",
    fillOpacity: 0.225634
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0895 9.10281L17.0296 9.2816C16.98 9.4251 16.8215 9.50501 16.6754 9.456L12.9754 8.26145C12.8264 8.21229 12.7476 8.05655 12.7944 7.9129L13.8064 4.87855C13.8532 4.7349 14.0117 4.655 14.1579 4.704L14.4752 4.80609L13.5142 7.50957C13.4517 7.68547 13.5453 7.88058 13.7244 7.94234L17.0895 9.10281Z",
    fill: "#0009AD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_687_2735",
    x: 0.719109,
    y: 0.546013,
    width: 18.1829,
    height: 22.408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.17133,
    result: "effect1_foregroundBlur_687_2735"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_687_2735",
    x: -2.92832,
    y: -4.92832,
    width: 25.7524,
    height: 33.3566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.96416
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_2735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_2735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_687_2735",
    x: 7.90601,
    y: 3.93945,
    width: 12.3975,
    height: 18.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.592157 0 0 0 0 0.0392157 0 0 0 0.476535 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_2735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_2735",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVialIcon);
export default __webpack_public_path__ + "static/media/vial-icon.e6b2e0a109b9b22ea2854dbc78c58ebd.svg";
export { ForwardRef as ReactComponent };